import Dashboard from "./Dashboard";
import Campaigns from "./Campaigns";
import Leads from "./Leads";
import Templates from "./Templates";
import Senders from "./Senders";
import Schedules from "./Schedules";

const CRMWrapper = ({ children }) => (
  <div className="crm-module">{children}</div>
);

const allRoutes = [
  ...Dashboard,
  ...Campaigns,
  ...Leads,
  ...Templates,
  ...Senders,
  ...Schedules,
];

const routes = allRoutes.map((route) => ({
  ...route,
  element: <CRMWrapper>{route.element}</CRMWrapper>,
}));

export default routes;
